import { ExamMaster } from "./ExamMaster.model";
import { LookupData } from "./LookupData.model";
import { McqMaster } from "./McqMaster.model";
import { MCQOptionMaster } from "./MCQOptionMaster.model";

export class ExamMCQMaster{
    public examMCQMasterId: number;
    public examMaster: ExamMaster;
    public examMasterId: number;
    public mcqMaster: McqMaster;
    public mcqMasterId: number;
    public mcqOptionMaster: MCQOptionMaster;
    public mcqOptionMasterId: number;
    public marks: number;
    public srNo: number;
    public durationLeftInSeconds: number;
    public attempts: number;
    public isDelete: string;
    public isSkipped: boolean;
    public pageNumber: number;
    public pageSize: number;
    public isCompleted: boolean;
    public buttonType: string;
    public errorMessage: string;
    public type: LookupData;
    public typeList: LookupData[];
    public totalMCQ: number;

}